// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css';
import App from './App';
import router from './router';
import FirebasePlugin from './plugins/firebase';

Vue.use(FirebasePlugin, {
  apiKey: 'AIzaSyD5c5K27AJLLGkxADPrxAXobzAdIbsUTWM',
  authDomain: 'became-bot.firebaseapp.com',
  databaseURL: 'https://became-bot.firebaseio.com',
  projectId: 'became-bot',
  storageBucket: 'became-bot.appspot.com',
  messagingSenderId: '834055095429',
});

Vue.use(Vuetify, {
  theme: {
    //    primary: '#4b88a2',
    primary: '#fff',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
  iconfont: 'fa',
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js